<template>
  <div
    class="d-flex flex-wrap"
    :class="[ spacingBetween ? 'mw-flex-gap' : '']"
    :style="cssVars"
  >
    <flex-item
      v-for="(item, index) in $slots.items"
      :key="index"
      :class="extraClass"
      :style="{ width: widthItem }"
      :vnode="item"
    />
  </div>
</template>

<script>

export default {
  components: {
    FlexItem: // Componente funcional
                {
                  functional: true,
                  render: (h, context) => {
                    return h('div', { style: context.data.style, class: context.data.class }, [context.data.attrs.vnode])
                  }
                }
  },
  props: {
    itemsMobile: { type: Number, default: 2 },
    itemsTablet: { type: Number, default: 4 },
    itemsDesktop: { type: Number, default: 4 },
    spacingSize: { type: Number, default: 10 },
    spacingBetween: { type: Boolean, default: false },
    isItem: { type: Boolean },
    itemClass: { type: String, default: 'd-flex' }
  },
  data () {
    return {
      display: '',
      widthItem: '',
      extraClass: ''
    }
  },
  computed: {
    cssVars () {
      if (this.spacingBetween) {
        return {
          '--spacing-gap': this.spacingSize + 'px'
        }
      } else {
        return {}
      }
    }
  },
  mounted () {
    this.onInit(window.innerWidth)
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    setItemWidth (size) {
      if (size === 'sm' || size === 'xs') {
        return (100 / this.itemsMobile).toString() + '%'
      } else if (size === 'md') {
        return (100 / this.itemsTablet).toString() + '%'
      } else {
        return (100 / this.itemsDesktop).toString() + '%'
      }
    },
    onResize () {
      if (window.innerWidth > 992) {
        this.display = 'lg'
        this.widthItem = this.setItemWidth(this.display)
        this.extraClass = this.itemClass
      } else if (window.innerWidth > 768) {
        this.display = 'md'
        this.widthItem = this.setItemWidth(this.display)
        this.extraClass = this.itemClass
      } else if (window.innerWidth > 576) {
        this.display = 'sm'
        this.widthItem = this.setItemWidth(this.display)
        this.extraClass = this.itemClass
      } else {
        this.display = 'xs'
        this.widthItem = this.setItemWidth(this.display)
        if (this.isItem && this.itemsMobile > 1) {
          this.extraClass = 'columns-mobile ' + this.itemClass
        } else if (this.isItem && this.itemsMobile === 1) {
          this.extraClass = 'single-column-item ' + this.itemClass
        }
      }
    },
    onInit (size) {
      if (size > 992) {
        this.display = 'lg'
        this.widthItem = this.setItemWidth(this.display)
        this.extraClass = this.itemClass
      } else if (size > 768) {
        this.display = 'md'
        this.widthItem = this.setItemWidth(this.display)
        this.extraClass = this.itemClass
      } else if (window.innerWidth > 576) {
        this.display = 'sm'
        this.widthItem = this.setItemWidth(this.display)
        this.extraClass = this.itemClass
      } else {
        this.display = 'xs'
        this.widthItem = this.setItemWidth(this.display)
        if (this.isItem && this.itemsMobile > 1) {
          this.extraClass = 'columns-mobile ' + this.itemClass
        } else if (this.isItem && this.itemsMobile === 1) {
          this.extraClass = 'single-column-item ' + this.itemClass
        }
      }
    }
  }
}

</script>

<style scoped>

    .mw-flex-gap {
        padding: var(--spacing-gap) 0 0 var(--spacing-gap);
        margin: calc(0px - var(--spacing-gap));
    }

    .mw-flex-gap > * {

        border: 0 solid transparent;
        border-width: 0 var(--spacing-gap) var(--spacing-gap) 0;
        background-clip: padding-box;
    }

</style>
